<template>
  <div class="modal fade modalContainer" tabindex="-1" role="dialog" :class="situtation">
    <div class="modal-dialog  modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close" data-dismiss="modal" :onclick="modalKapat"  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Modal',
  data () {
    return {
      situtation: this.className
    }
  },
  props: {
    className: {
      type: String,
      default: 'hide'
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    modalKapat () {
      this.situtation = 'hide'
      this.$emit('on-closed', 'hide')
    }
  },
  watch: {
    className: function (v) {
      this.situtation = this.className
    }
  }
}
</script>

<style scoped>
.hide{
  display:none
}
.show{
  display:block
}
.modalContainer{
  background:rgba(255,0,0,0.5);
}
</style>
